import React from 'react';
import { FaHome, FaBuilding, FaKey, FaHandshake, FaChartLine, FaFileContract } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaHome />,
      title: 'Property Buying',
      description: 'Expert guidance in finding and purchasing your ideal residential or commercial property'
    },
    {
      icon: <FaBuilding />,
      title: 'Property Selling',
      description: 'Professional marketing and selling services to get the best value for your property'
    },
    {
      icon: <FaKey />,
      title: 'Rental Services',
      description: 'Comprehensive rental solutions for apartments, offices, and commercial spaces'
    },
    {
      icon: <FaHandshake />,
      title: 'Property Consultation',
      description: 'Expert advice on property investment, market trends, and valuation'
    },
    {
      icon: <FaChartLine />,
      title: 'Market Analysis',
      description: 'In-depth market research and property evaluation for informed decisions'
    },
    {
      icon: <FaFileContract />,
      title: 'Legal Assistance',
      description: 'Complete support with documentation, registration, and legal formalities'
    }
  ];

  return (
    <section className="services section-padding" id="services">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>Comprehensive Real Estate Solutions Tailored for You</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;